import { useAppTheme } from './use-app-theme'
import { useMediaQuery } from './use-media-query'

export const useIsTabletDown = () => {
  const theme = useAppTheme()
  return useMediaQuery(`screen and (max-width: ${theme.breakpoints.values.lg - 1}px)`)
}
